"use strict";
/**
 * Enumeration User permissions
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPermissionType = void 0;
var UserPermissionType;
(function (UserPermissionType) {
    UserPermissionType["READ_DASHBOARD"] = "read:dashboard";
})(UserPermissionType || (exports.UserPermissionType = UserPermissionType = {}));
//# sourceMappingURL=UserPermissionType.js.map